import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./groupdesign/ListofGroup.css";
import DeleteButton from "../icon/deleteicon";
import { getApiBaseUrl } from "../../config/api";
import {
  formatGroupDeleteAt,
  isGroupDeactivated,
  isGroupPendingDelete,
} from "../../utils/groupRole";

const API_URL = getApiBaseUrl();

function resolveStoredUser() {
  try {
    const raw = localStorage.getItem("forumUser") || localStorage.getItem("user");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export default function GetGroups({ isAdmin, deleteGroup: deleteGroupProp, user: userProp }) {
  const [allGroups, setAllGroups] = useState([]);
  const user = userProp || resolveStoredUser();

  const fetchAllGroups = async () => {
    if (!isAdmin) return;
    try {
      const params = new URLSearchParams();
      if (user?.id) params.set('user_id', String(user.id));
      const res = await fetch(`${API_URL}/get_all_groups.php?${params}`);
      const data = await res.json();
      if (data.success) setAllGroups(data.groups || []);
      else console.error("Failed to fetch all groups:", data.message);
    } catch (err) {
      console.error("Error fetching all groups:", err);
    }
  };

  useEffect(() => {
    fetchAllGroups();
  }, [isAdmin, user?.id]);

  const deleteGroup = async (groupId) => {
    if (deleteGroupProp) {
      await deleteGroupProp(groupId);
      fetchAllGroups();
      return;
    }
    if (!user?.id) {
      alert("You must be logged in to delete a group.");
      return;
    }
    if (
      !window.confirm(
        isAdmin
          ? "Permanently delete this group now? This cannot be undone, even if someone else owns it."
          : "This group will be deactivated now and permanently deleted after 3 days. You can cancel this from the group page until then. Continue?"
      )
    ) {
      return;
    }
    try {
      const res = await fetch(`${API_URL}/delete_group.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          group_id: groupId,
          user_id: user.id,
          action: isAdmin ? "purge" : "delete",
          confirmed: true,
        }),
      });
      const data = await res.json();
      if (data.success) {
        alert(data.message || (isAdmin ? "Group permanently deleted." : "Group scheduled for deletion."));
        fetchAllGroups();
      } else {
        alert(data.message || "Failed to delete group.");
      }
    } catch (err) {
      console.error("Error deleting group:", err);
    }
  };

  const buildPhotoUrl = (photo) => {
    const fallback = "https://fms.techtreeglobal.com/assets/uploads/1743233100_key.png";
    if (!photo) return fallback;
    if (/^https?:\/\//i.test(photo)) return photo;
    const base = API_URL.replace(/\/+$/, "");
    if (photo.startsWith("/")) return `${base}${photo}`;
    if (photo.includes("uploads/")) return `${base}/${photo}`;
    return `${base}/uploads/groups/${photo}`;
  };

  return (
    <div className="group-list2">
      {allGroups.length === 0 ? (
        <p>No groups found.</p>
      ) : (
        allGroups.map((g) => {
          const photoUrl = buildPhotoUrl(g.group_photos);
          const groupName = g.name || "Untitled Group";
          const groupDesc = g.description || "No description";

          return (
            <div
              key={g.id}
              className="group-cardlist2"
              style={{ position: "relative" }} // ✅ Needed for absolute button
            >
              {isAdmin && (
                <button
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    deleteGroup(g.id);
                  }}
                  style={{
                    position: "absolute",
                    top: "10px",
                    right: "10px",
                    background: "none",
                    border: "none",
                    zIndex: 2,
                  }}
                  title="Permanently delete this group"
                >
                  <DeleteButton />
                </button>
              )}

              <Link
                to={`/group/${g.id}`}
                style={{ textDecoration: "none", color: "inherit", display: "block" }}
              >
                <div className="card-image">
                  <img
                    src={photoUrl}
                    alt={groupName}
                    onError={(e) =>
                      (e.currentTarget.src =
                        "https://fms.techtreeglobal.com/assets/uploads/1743233100_key.png")
                    }
                  />
                </div>
                <div className="card-content">
                  <h3 style={{ textAlign: "center", margin: "10px 0" }}>{groupName}</h3>
                  {isGroupPendingDelete(g) ? (
                    <p style={{ textAlign: "center", fontSize: "0.75rem", color: "#c2410c", margin: 0 }}>
                      Deletes {formatGroupDeleteAt(g.scheduled_delete_at) || "in 3 days"}
                    </p>
                  ) : isGroupDeactivated(g) ? (
                    <p style={{ textAlign: "center", fontSize: "0.75rem", color: "#be123c", margin: 0 }}>
                      Deactivated
                    </p>
                  ) : null}
                  {g.owner_name ? (
                    <p style={{ textAlign: "center", fontSize: "0.75rem", color: "#64748b", margin: "0 0 4px" }}>
                      Owner: {g.owner_name}
                    </p>
                  ) : null}
                  <p style={{ textAlign: "center", fontSize: "0.9rem", color: "#555" }}>
                    {groupDesc.length > 80 ? groupDesc.slice(0, 80) + "..." : groupDesc}
                  </p>
                   <p style={{ textAlign: "center", fontSize: "0.9rem", color: "#0e1df0ff" }}>View Group</p>
                </div>
              </Link>
            </div>
          );
        })
      )}
    </div>
  );
}
